import {i as l} from '@theme/component-dynamic-modal-content';
const n = {
    trigger: '[data-modal-trigger]',
    close: '[data-modal-close]',
    overlay: '[data-modal-overlay]',
    dialog: '.component-modal__dialog',
    focusableElements: 'button, [href], input, textarea, select, details, [tabindex]:not([tabindex="-1"])',
    modalTriggers: (o) => `[data-modal-trigger="${o}"]`,
  },
  a = 'modals:close-others',
  d = 'modals:close-all';
class r extends HTMLElement {
  constructor() {
    super(),
      (this.modalId = null),
      (this.modalType = null),
      (this.isOpen = !1),
      (this.eventTrigger = null),
      (this.animationDurationMs = 500),
      (this.elements = {close: null, overlay: null, dialog: null, focusableElements: []}),
      (this.modalTriggers = []);
  }
  connectedCallback() {
    (this.modalId = this.getAttribute('data-modal-id')),
      (this.modalType = this.getAttribute('data-modal-type')),
      window.modals.push({id: this.modalId, modal: this}),
      (this.modalTriggers = document.querySelectorAll(n.modalTriggers(this.modalId))),
      (this.dynamicModalContent = this.querySelector('component-dynamic-modal-content')),
      (this.elements.close = this.querySelector(n.close)),
      (this.elements.overlay = this.querySelector(n.overlay)),
      (this.elements.dialog = this.querySelector(n.dialog)),
      (this.elements.focusableElements = this.querySelectorAll(n.focusableElements)),
      this.initEventListeners(),
      this.initFocusTrap(),
      this.initAnimation();
  }
  initEventListeners() {
    var e, t;
    this.modalTriggers.forEach((i) => {
      i.addEventListener('click', (s) => {
        s.preventDefault(), (this.eventTrigger = s), this.open();
      }),
        i.addEventListener('mouseenter', () => {
          var s;
          (s = this.dynamicModalContent) == null || s.loadContent();
        });
    }),
      (e = this.elements.close) == null || e.addEventListener('click', () => this.close()),
      (t = this.elements.overlay) == null || t.addEventListener('click', () => this.close()),
      document.addEventListener(d, () => this.close()),
      document.addEventListener(a, (i) => {
        this.modalId !== i.detail.modalId && this.close();
      });
  }
  initAnimation() {
    const e = this.modalType === 'drawer' ? 'X' : 'Y';
    (this.elements.dialog.style.transition = `transform ${this.animationDurationMs}ms`),
      (this.elements.dialog.style.transform = `translate${e}(100%)`),
      (this.elements.overlay.style.transition = `opacity ${this.animationDurationMs}ms`),
      (this.elements.overlay.style.opacity = 0);
  }
  open() {
    var e;
    this.isOpen ||
      ((e = this.dynamicModalContent) == null || e.loadContent(),
      this.handleModalStateChange('open'),
      setTimeout(() => {
        this.handleStateChangeAnimation('open');
      }, 50),
      setTimeout(() => {
        const t = this.elements.focusableElements[0];
        t == null || t.focus();
      }, this.animationDurationMs + 100));
  }
  close() {
    this.isOpen &&
      (this.handleStateChangeAnimation('close'),
      setTimeout(() => {
        this.handleModalStateChange('close'),
          this.eventTrigger && (this.eventTrigger.target.focus(), (this.eventTrigger = null));
      }, this.animationDurationMs));
  }
  handleModalStateChange(e) {
    if (e === 'open') {
      document.dispatchEvent(new CustomEvent(a, {detail: {modalId: this.modalId}})),
        (this.isOpen = !0),
        this.setAttribute('aria-hidden', 'false'),
        (document.body.style.overflow = 'hidden'),
        (this.elements.dialog.scrollTop = 0);
      return;
    }
    (this.isOpen = !1), this.setAttribute('aria-hidden', 'true'), (document.body.style.overflow = '');
  }
  handleStateChangeAnimation(e) {
    const t = this.modalType === 'drawer' ? 'X' : 'Y';
    if (e === 'open') {
      (this.elements.dialog.style.transform = `translate${t}(0)`), (this.elements.overlay.style.opacity = 1);
      return;
    }
    (this.elements.dialog.style.transform = `translate${t}(100%)`), (this.elements.overlay.style.opacity = 0);
  }
  initFocusTrap() {
    this.addEventListener('keydown', (s) => {
      s.key === 'Escape' && this.close();
    });
    const e = this.elements.focusableElements;
    if (e.length === 0) return;
    const t = e[0],
      i = e[e.length - 1];
    this.addEventListener('keydown', (s) => {
      s.key === 'Tab' &&
        (s.shiftKey && document.activeElement === t
          ? (s.preventDefault(), i.focus())
          : document.activeElement === i && (s.preventDefault(), t.focus()));
    });
  }
}
function h() {
  (window.modals = []), customElements.define('component-modal', r), l();
}
export {h as i};
